export default __webpack_public_path__ + "308d45dfa8e0d614b82badf78a406d18.foto_en_preparacion.png";